import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.getPOPDFLabelSetFields.views.poPDFLabelSectionEditor`

export default defineMessages({
  poFieldsSectionTitle: {
    id: `${scope}.poFieldsSectionTitle`,
    defaultMessage: 'PO fields',
  },
  poCostsSectionTitle: {
    id: `${scope}.poCostsSectionTitle`,
    defaultMessage: 'PO costs',
  },
  itemFieldsSectionTitle: {
    id: `${scope}.itemFieldsSectionTitle`,
    defaultMessage: 'Item fields',
  },
  poCustomFieldLabelsSubSectionTitle: {
    id: `${scope}.poCustomFieldLabelsSubSectionTitle`,
    defaultMessage: 'PO custom field labels',
  },
  itemFieldsCustomFieldLabelsSubSectionTitle: {
    id: `${scope}.itemFieldsCustomFieldLabelsSubSectionTitle`,
    defaultMessage: 'Item fields custom field labels',
  },
  existingLabelsColumnHeader: {
    id: `${scope}.existingLabelsColumnHeader`,
    defaultMessage: 'Existing labels',
  },
  replaceWithColumnHeader: {
    id: `${scope}.replaceWithColumnHeader`,
    defaultMessage: 'Replace with',
  },
  sectionHelpAriaLabel: {
    id: `${scope}.sectionHelpAriaLabel`,
    defaultMessage: 'Help for {title}',
  },
  replaceWithInputAriaLabel: {
    id: `${scope}.replaceWithInputAriaLabel`,
    defaultMessage: 'Replace label for {label}',
  },
})
